import * as React from "react";
import { useLocation } from "react-router-dom";
import { usePageEnvelope } from "./PageEnvelope";
import { normalizeQuery } from "../opportunityResult/util";

export interface OpportunitySearchQueryState {
  keyword?: null | string;
  where?: null | string;
  radius?: number;
  category?: number[];
  typeofwork?: number[];
  commitment?: number[];
  suitablefor?: number[];
  daytime?: number[];
  organisationId?: null | string;
  page?: null | number;
}

export const defaultOpportunitySearchQuery: OpportunitySearchQueryState = {
  keyword: null,
  where: null,
  radius: 0,
  category: [],
  typeofwork: [],
  commitment: [],
  suitablefor: [],
  daytime: [],
  organisationId: null,
  page: null,
};

export const OpportunitySearchQueryStateContext = React.createContext<
  OpportunitySearchQueryState | undefined
>(undefined);

export const OpportunitySearchQueryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation<{
    searchQuery?: OpportunitySearchQueryState;
  }>();

  const { pageEnvelope } = usePageEnvelope<{
    searchCriteria?: OpportunitySearchQueryState;
  }>();

  const searchQuery = React.useMemo(() => {
    // console.log(pageEnvelope.data?.searchCriteria);
    // console.log(location.state?.searchQuery);

    const query: OpportunitySearchQueryState = normalizeQuery(
      Object.assign(
        {},
        defaultOpportunitySearchQuery,
        location.state?.searchQuery || pageEnvelope.data?.searchCriteria
      )
    );

    return query;
  }, [location.state, pageEnvelope.data]);

  return (
    <OpportunitySearchQueryStateContext.Provider value={searchQuery}>
      {children}
    </OpportunitySearchQueryStateContext.Provider>
  );
};

export const useOpportunitySearchQuery = (): OpportunitySearchQueryState => {
  const searchQuery = React.useContext(OpportunitySearchQueryStateContext);
  return searchQuery;
};
